module.exports = __webpack_public_path__ + "static/media/customer.3a740a7f.png";